module.exports = __webpack_public_path__ + "static/draftin-0a17876a60117d6eaed3cd3f5bd41cf0.png";